module.exports = __webpack_public_path__ + "media/images/user-relations-icon-43e76772d3cf1254f161042224ad9b96.svg";